import React from 'react';
import Grid from 'components/Custom/Grid';
import { getWorkforceLabor } from 'utils/WorkforceLaborUtils';
import WorkforceLabor from 'classes/WorkforceLabor';
import { useAppContext } from 'hooks/useAppContext';

export default function WorkforceLaborGrid() {
  const columns = WorkforceLabor.columns;
  const { selectedProject } = useAppContext();

  return (
    <Grid
      columns={columns}
      title="Workforce Labor"
      getRecords={getWorkforceLabor}
      selectedProject={selectedProject}
      component="Inspections"
      enable={{ update: false, delete: false }}
      inspectionColumnTitle="Inspection #"
      options={{
        pageSizeOptions: [10, 15, 25],
        pageSize: 10
      }}
    />
  );
}
